import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'swb-news',
  templateUrl: './news.component.html'
})
export class NewsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
